<template>

  <div @click="clickMarker" ref="sceneMaterialPoint"
       :style="{'animation-name':animationName,'animation-duration':animationDuration+'s','z-index':this.pointInfo.showSet.showTop ? 1 : 0,
       'display':this.pointInfo.showSet.totalVisible ? 'block' : 'none','overflow':animationing ? 'hidden' : ''}"
       class="sceneMaterialPoint alibabaPuHuiTiFontFamily">
    <!--内部各元素等图片加载完成 且 动画开始 再进行显示-->
    <img v-if="getPointImageFinishTimeout  && ((!this.pointInfo.showSet.defaultStyle && !this.pointInfo.showSet.showMarkerImage) || this.pointInfo.showSet.defaultStyle)"
         :style="{'width':this.pointInfo.showSet.defaultStyle ? '60px' : pointInfo.geoJson.geo.properties.size*100+'px',
         'height':this.pointInfo.showSet.defaultStyle ? '60px' : pointInfo.geoJson.geo.properties.size*100+'px',
         'animation-name':animationImageName,'animation-duration':animationDuration+'s'}" style="animation-fill-mode:forwards;"
         :src="require('../../../assets/mapbox/marker_image/' + pointImageFolder + '/' + pointImageName + '.png')">
    <img ref="showMarkerImage_img" v-if="getPointImageFinishTimeout && (!this.pointInfo.showSet.defaultStyle && this.pointInfo.showSet.showMarkerImage)"
         :style="{'animation-name':animationImageName,'animation-duration':animationDuration+'s'}"
         :src="markerFirstImageSrc" style="width:100px;height:100px;animation-fill-mode:forwards;">
    <!--名称-->
    <div v-show="getPointImageFinishTimeout && (pointInfo.showSet.showName && ((!this.pointInfo.showSet.defaultStyle && !this.pointInfo.showSet.showMarkerImage) || this.pointInfo.showSet.defaultStyle))"
         :style="{'bottom':this.pointInfo.showSet.defaultStyle ? '75px' : pointInfo.geoJson.geo.properties.size*100+15 + 'px'}"
         style="position:absolute;left:-50%;right:-50%;text-align:center;color:#ffffff;font-size:16px;text-shadow: 1px 1px 2px rgba(0,0,0,0.9);">
      <p style="line-height:20px;">{{pointInfo.name}}</p>
    </div>
    <div v-show="getPointImageFinishTimeout && (pointInfo.showSet.showName && (!this.pointInfo.showSet.defaultStyle && this.pointInfo.showSet.showMarkerImage))"
         style="position:absolute;left:-50%;right:-50%;bottom:115px;text-align:center;color:#ffffff;font-size:16px;text-shadow: 1px 1px 2px rgba(0,0,0,0.9);">
      <p style="line-height:20px;">{{pointInfo.name}}</p>
    </div>

  </div>

</template>

<script>
import mapboxgl from "mapbox-gl";
import * as turf from "@turf/turf";

export default {
  name: "SceneMaterialPoint",
  props:["pointInfo","pointIndex"],
  data() {
    return {
      marker: '',

      pointImageList:[
        {
          icon:"&#xe6b6;",
          colorAndImageList:[
            {
              color:"#FF0000",
              image:"marker_one_red1"
            },
            {
              color:"#FFC800",
              image:"marker_one_yellow1"
            },
            {
              color:"#2A82E4",
              image:"marker_one_blue1"
            },
            {
              color:"#00FF00",
              image:"marker_one_green1"
            },
            {
              color:"#00FFFF",
              image:"marker_one_cyan1"
            },
          ]
        },
        {
          icon:"&#xe657;",
          colorAndImageList:[
            {
              color:"#FF0000",
              image:"marker_two_red1"
            },
            {
              color:"#FFC800",
              image:"marker_two_yellow1"
            },
            {
              color:"#2A82E4",
              image:"marker_two_blue1"
            },
            {
              color:"#00FF00",
              image:"marker_two_green1"
            },
            {
              color:"#00FFFF",
              image:"marker_two_cyan1"
            },
          ]
        },
        {
          icon:"&#xe653;",
          colorAndImageList:[
            {
              color:"#FF0000",
              image:"marker_three_red1"
            },
            {
              color:"#FFC800",
              image:"marker_three_yellow1"
            },
            {
              color:"#2A82E4",
              image:"marker_three_blue1"
            },
            {
              color:"#00FF00",
              image:"marker_three_green1"
            },
            {
              color:"#00FFFF",
              image:"marker_three_cyan1"
            },
          ]
        },
        {
          icon:"&#xe65a;",
          colorAndImageList:[
            {
              color:"#FF0000",
              image:"marker_four_red1"
            },
            {
              color:"#FFC800",
              image:"marker_four_yellow1"
            },
            {
              color:"#2A82E4",
              image:"marker_four_blue1"
            },
            {
              color:"#00FF00",
              image:"marker_four_green1"
            },
            {
              color:"#00FFFF",
              image:"marker_four_cyan1"
            },
          ]
        },
        {
          icon:"&#xe63c;",
          colorAndImageList:[
            {
              color:"#FF0000",
              image:"marker_five_red1"
            },
            {
              color:"#FFC800",
              image:"marker_five_yellow1"
            },
            {
              color:"#2A82E4",
              image:"marker_five_blue1"
            },
            {
              color:"#00FF00",
              image:"marker_five_green1"
            },
            {
              color:"#00FFFF",
              image:"marker_five_cyan1"
            },
          ]
        },
        {
          icon:"&#xe651;",
          colorAndImageList:[
            {
              color:"#FF0000",
              image:"marker_six_red1"
            },
            {
              color:"#FFC800",
              image:"marker_six_yellow1"
            },
            {
              color:"#2A82E4",
              image:"marker_six_blue1"
            },
            {
              color:"#00FF00",
              image:"marker_six_green1"
            },
            {
              color:"#00FFFF",
              image:"marker_six_cyan1"
            },
          ]
        },
        {
          icon:"&#xe664;",
          colorAndImageList:[
            {
              color:"#FF0000",
              image:"marker_seven_red1"
            },
            {
              color:"#FFC800",
              image:"marker_seven_yellow1"
            },
            {
              color:"#2A82E4",
              image:"marker_seven_blue1"
            },
            {
              color:"#00FF00",
              image:"marker_seven_green1"
            },
            {
              color:"#00FFFF",
              image:"marker_seven_cyan1"
            },
          ]
        },
        {
          icon:"&#xe654;",
          colorAndImageList:[
            {
              color:"#FF0000",
              image:"marker_eight_red1"
            },
            {
              color:"#FFC800",
              image:"marker_eight_yellow1"
            },
            {
              color:"#2A82E4",
              image:"marker_eight_blue1"
            },
            {
              color:"#00FF00",
              image:"marker_eight_green1"
            },
            {
              color:"#00FFFF",
              image:"marker_eight_cyan1"
            },
          ]
        },
        {
          icon:"&#xe656;",
          colorAndImageList:[
            {
              color:"#FF0000",
              image:"marker_nine_red1"
            },
            {
              color:"#FFC800",
              image:"marker_nine_yellow1"
            },
            {
              color:"#2A82E4",
              image:"marker_nine_blue1"
            },
            {
              color:"#00FF00",
              image:"marker_nine_green1"
            },
            {
              color:"#00FFFF",
              image:"marker_nine_cyan1"
            },
          ]
        },

      ],
      pointImageName:"",
      pointImageFolder:"",
      getPointImageFinish:false,
      getPointImageFinishTimeout:false,

      markerFirstImageSrc:"",

      markerShowAnimationBeginSeconds:0,   //开始动画前的秒数  ms
      markerShowSeconds:0,   //持续的秒数  ms
      markerHideAnimationEndSeconds:0,   //隐藏动画结束时的秒数  ms

      //绑定在整体的动画
      animationName:"",
      animationDuration:"1",
      //绑定在图片的动画
      animationImageName:"",

      animationShowTemp:"",    //监听开始出现
      animationingTemp:"",    //监听动画过程中
      animationing:false,
      animationHideTemp:"",    //监听开始隐藏
      animationFinishTemp:"",    //监听结束延时


    }
  },
  computed: {
    //监听变量深拷贝，解决深度监听时新值和旧值相同的问题
    pointInfo_computed() {
      return JSON.parse(JSON.stringify(this.pointInfo))
    },


  },
  watch:{
    pointInfo_computed:{
      handler(newVal, oldVal) {
        if((newVal.geoJson.geo.geometry.coordinates[0] !== oldVal.geoJson.geo.geometry.coordinates[0])
            || (newVal.geoJson.geo.geometry.coordinates[1] !== oldVal.geoJson.geo.geometry.coordinates[1])){
          //图标位置变化。重新定位
          this.marker.setLngLat(this.pointInfo.geoJson.geo.geometry.coordinates)
        }
        if(newVal.showSet.defaultStyle !== oldVal.showSet.defaultStyle){
          if(this.pointInfo.showSet.defaultStyle){
            this.pointImageName = "marker_one_blue1"
            this.pointImageFolder = "marker_one"
            this.getPointImageFinish = true;
          }
          else{
            this.getPointImage(this.pointInfo.geoJson.geo.properties.code,this.pointInfo.geoJson.geo.properties.color);
          }
        }
      },
      deep: true
    },

    getPointImageFinish(){
      if(this.getPointImageFinish){

        setTimeout(()=>{
          this.getPointImageFinishTimeout = true

        },0)
      }

    },
  },
  methods:{
    clickMarker(){
      this.$emit("clickMarker",this.pointInfo)
    },
    //根据点的icon和color，获取图片
    getPointImage(icon,color){
      for(let i=0;i<this.pointImageList.length;i++){
        if(icon === this.pointImageList[i].icon){
          for(let j=0;j<this.pointImageList[i].colorAndImageList.length;j++){
            if(color === this.pointImageList[i].colorAndImageList[j].color){
              this.pointImageName = this.pointImageList[i].colorAndImageList[j].image
              break;
            }

          }
          break;
        }
      }
      let imageNameArr = this.pointImageName.split("_");
      this.pointImageFolder = imageNameArr[0] + "_" + imageNameArr[1];

      this.getPointImageFinish = true;

    },
    //根据点信息和当前录制点，获取点显示秒数(只有播放和预览时需要)
    getShowSeconds(){
      // console.log(this.$store.state.sceneCurrPlayItem)

      if(this.$store.state.sceneCurrPlayItem.viewPointList.length === 1){
        //单点录制点，showSet的timeRange必须是[0,1]才会显示
        // if(this.pointInfo.showSet.timeRange[0] === 0 && this.pointInfo.showSet.timeRange[1] === 1){

        //单点录制点，考虑动效有进场和离场，showSet的timeRange可以是[0,0]或[0,1]
        if(this.pointInfo.showSet.timeRange[0] === 0){
          //素材的开始动画前秒数为进场动画秒数
          //素材的显示秒数即录制点动效持续时间（加延时时间？）- 进场动画秒数
          //素材动效结束秒数，当素材动效结束点在最后一个视野点时，即录制点动效持续时间（加延时时间？）- 离场动画秒数；当素材动效结束点在“结束”时，即录制点动效持续时间（加延时时间？）
          switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
            case "螺旋凝视":{
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.rotate.timeout * 1000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.rotate.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.rotate.timeout) * 1000
              break;
            }
            case "太空俯冲":{
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.slide.timeout * 1000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.slide.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.slide.timeout) * 1000
              break;
            }
            case "地球自转":{
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.earthRotation.timeout * 1000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.earthRotation.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.earthRotation.timeout) * 1000
              break;
            }
            case "高空悬停":{
              //进场动效1秒
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomSubAndHovering.timeout * 1000 + 1000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomSubAndHovering.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomSubAndHovering.timeout) * 1000
              break;
            }
            case "螺旋环绕":{
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotate.timeout * 1000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotate.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotate.timeout) * 1000
              break;
            }
            case "螺旋靠近":{
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.timeout * 1000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndPitchAddAndRotateZoomAdd.timeout) * 1000
              break;
            }
            case "俯冲环绕":{
              //进场动效5秒
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndRotate.timeout * 1000 + 5000;
              this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndRotate.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndRotate.timeout) * 1000
              break;
            }
            case "俯冲观测":{
              //进场动效800毫秒，离场动效800毫秒
              this.markerShowAnimationBeginSeconds = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.timeout * 1000 + 800;
              if(this.pointInfo.showSet.timeRange[1] === 1){
                //素材动效在“结束”点位停止
                this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.timeout) * 1000
              }
              else{
                //素材动效在视野点位停止，需要去除离场时间
                this.markerHideAnimationEndSeconds = (this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.duration + this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndHovering.timeout) * 1000 - 800
              }
              break;
            }
          }
          this.markerShowSeconds = this.markerHideAnimationEndSeconds - this.markerShowAnimationBeginSeconds;

        }
      }
      else{
        //多录制点
        if(this.pointInfo.showSet.timeRange[0] !== this.pointInfo.showSet.timeRange[1]){
          //有显示时间
          if(this.pointInfo.showSet.timeRange[0] === this.$store.state.sceneCurrPlayItem.viewPointList.length-1
              && this.pointInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
            //时间范围是最后一个视野点开始到结束，平移跟踪效果中最后一个视野点没有时间，所以等于没有显示时间

          }
          else{
            //有正常显示范围
            console.log(this.pointInfo.showSet.timeRange)

            //路线动画总时长 无进场离场的动效即为设置的时间
            let routeDuration;
            switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
              case "平移跟踪":{
                routeDuration = this.$store.state.sceneCurrPlayItem.pointAnimationParam.route.duration * 1000;
                break;
              }
              case "侧向跟踪":{
                routeDuration = this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithChangeBearing.duration * 1000;
                break;
              }
              case "空中游览":{
                //该动效开头有2秒调整zoom，所有点位结束后有3秒延时
                routeDuration = this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndFlyByPath.duration * 1000 - 5000;
                break;
              }
              case "模拟驾驶":{
                //该动效开头有2秒调整zoom，所有点位结束后有3秒延时
                routeDuration = this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithWatchNextPoint.duration * 1000 - 5000;
                break;
              }

            }





            //总路线长度
            let routePoints = [];
            for(let i=0;i<this.$store.state.sceneCurrPlayItem.viewPointList.length;i++){
              routePoints.push([this.$store.state.sceneCurrPlayItem.viewPointList[i].lng,this.$store.state.sceneCurrPlayItem.viewPointList[i].lat])
            }
            let routeDistance = turf.lineDistance(turf.lineString(routePoints));

            //开始动画视野点距初始点的长度
            if(this.pointInfo.showSet.timeRange[0] !== 0){
              let routePointsBeginAnimation = [];
              for(let i=0;i<=this.pointInfo.showSet.timeRange[0];i++){
                routePointsBeginAnimation.push([this.$store.state.sceneCurrPlayItem.viewPointList[i].lng,this.$store.state.sceneCurrPlayItem.viewPointList[i].lat])
              }
              let routeDistanceBeginAnimation = turf.lineDistance(turf.lineString(routePointsBeginAnimation));
              //根据比例计算 路线进行到开始动画视野点的时长，即开始动画前的秒数
              this.markerShowAnimationBeginSeconds = routeDistanceBeginAnimation / routeDistance * routeDuration;

              switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
                case "空中游览":{
                  //该动效开头有2秒调整zoom，动效开始时间需要加2秒
                  this.markerShowAnimationBeginSeconds = this.markerShowAnimationBeginSeconds + 2000;
                  break;
                }
                case "模拟驾驶":{
                  //该动效开头有2秒调整zoom，动效开始时间需要加2秒
                  this.markerShowAnimationBeginSeconds = this.markerShowAnimationBeginSeconds + 2000;
                  break;
                }
              }
            }
            else{
              //开始动画在0秒就开始
              switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
                case "空中游览":{
                  //该动效开头有2秒调整zoom，动效开始时间需要加2秒
                  this.markerShowAnimationBeginSeconds = 2000;
                  break;
                }
                case "模拟驾驶":{
                  //该动效开头有2秒调整zoom，动效开始时间需要加2秒
                  this.markerShowAnimationBeginSeconds = 2000;
                  break;
                }
              }
            }


            //开始时间前需要加上延时
            switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
              case "平移跟踪":{
                this.markerShowAnimationBeginSeconds = this.markerShowAnimationBeginSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.route.timeout * 1000
                break;
              }
              case "侧向跟踪":{
                this.markerShowAnimationBeginSeconds = this.markerShowAnimationBeginSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithChangeBearing.timeout * 1000
                break;
              }
              case "空中游览":{
                this.markerShowAnimationBeginSeconds = this.markerShowAnimationBeginSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndFlyByPath.timeout * 1000
                break;
              }
              case "模拟驾驶":{
                this.markerShowAnimationBeginSeconds = this.markerShowAnimationBeginSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithWatchNextPoint.timeout * 1000
                break;
              }

            }


            //结束动画视野点距初始点的长度
            let routePointsEndAnimation = [];
            let routePointsEndAnimationNum;

            if(this.pointInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
              //在 结束 点
              routePointsEndAnimationNum = this.pointInfo.showSet.timeRange[1]-1
            }
            // else if(this.pointInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length - 1){
            //   //在 最后一个视野点
            //   routePointsEndAnimationNum = this.pointInfo.showSet.timeRange[1]-1
            // }
            else{
              routePointsEndAnimationNum = this.pointInfo.showSet.timeRange[1]
            }
            for(let i=0;i<=routePointsEndAnimationNum;i++){
              routePointsEndAnimation.push([this.$store.state.sceneCurrPlayItem.viewPointList[i].lng,this.$store.state.sceneCurrPlayItem.viewPointList[i].lat])
            }
            let routeDistanceEndAnimation = turf.lineDistance(turf.lineString(routePointsEndAnimation));
            //根据比例计算 路线进行到结束动画视野点的时长，即结束动画结束时的秒数
            this.markerHideAnimationEndSeconds = routeDistanceEndAnimation / routeDistance * routeDuration;

            switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
              case "空中游览":{
                //该动效开头有2秒延时，最后一个视野点到结束有3秒离场
                if(this.pointInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
                  //动效显示时间段截止到结束点，需要在最后一个视野点的时间基础上增加开场延时+离场时间
                  this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds + 5000;
                }
                else{
                  //动效显示时间段截止到某视野点，需要在最后一个视野点的时间基础上增加开场延时
                  this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds + 2000;
                }

                break;
              }
              case "模拟驾驶":{
                //该动效开头有2秒延时，最后一个视野点到结束有3秒离场
                if(this.pointInfo.showSet.timeRange[1] === this.$store.state.sceneCurrPlayItem.viewPointList.length){
                  //动效显示时间段截止到结束点，需要在最后一个视野点的时间基础上增加开场延时+离场时间
                  this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds + 5000;
                }
                else{
                  //动效显示时间段截止到某视野点，需要在最后一个视野点的时间基础上增加开场延时
                  this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds + 2000;
                }

                break;
              }
            }

            //结束时间前需要加上延时
            switch(this.$store.state.sceneCurrPlayItem.pointAnimation){
              case "平移跟踪":{
                this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.route.timeout * 1000
                break;
              }
              case "侧向跟踪":{
                this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithChangeBearing.timeout * 1000
                break;
              }
              case "空中游览":{
                this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.zoomAddAndFlyByPath.timeout * 1000
                break;
              }
              case "模拟驾驶":{
                this.markerHideAnimationEndSeconds = this.markerHideAnimationEndSeconds +
                    this.$store.state.sceneCurrPlayItem.pointAnimationParam.flyByPathWithWatchNextPoint.timeout * 1000
                break;
              }

            }

            //素材显示时间
            this.markerShowSeconds = this.markerHideAnimationEndSeconds - this.markerShowAnimationBeginSeconds


          }

        }

      }



    },
    //开始显隐动画
    beginAnimation(){
      // console.log("开始显隐动画")
      // pointInfo.geoJson.geo.properties.size*100

      //css变量赋值
      if(this.pointInfo.showSet.showMarkerImage){
        this.$refs.sceneMaterialPoint.style.setProperty('--material-point-size', "100px")
      }
      else{
        this.$refs.sceneMaterialPoint.style.setProperty('--material-point-size',
            this.pointInfo.showSet.defaultStyle ? '60px' : this.pointInfo.geoJson.geo.properties.size*100+'px')
      }

      //监听开始动画前的秒数
      clearTimeout(this.animationShowTemp)
      this.animationShowTemp = setTimeout(()=>{
        // console.log("开始显示动画")
        this.$refs.sceneMaterialPoint.style.display = "block";
        //开始动画
        if(this.pointInfo.showSet.materialShowAnimation !== "无"){
          switch(this.pointInfo.showSet.materialShowAnimation){
            case "无":{

              break;
            }
            case "淡出":{
              this.animationName = "opacity0To1"
              break;
            }
            case "浮入":{
              this.animationName = "materialPointHeight0ToAll"
              break;
            }
            case "扩展":{
              this.animationImageName = "centerToAll"
              break;
            }
            case "翻跳":{
              if(this.pointInfo.showSet.showMarkerImage){
                this.$refs.sceneMaterialPoint.style.width = "100px"
                this.$refs.sceneMaterialPoint.style.height = "100px"
              }
              else{
                this.$refs.sceneMaterialPoint.style.width = this.pointInfo.showSet.defaultStyle ? '60px' : this.pointInfo.geoJson.geo.properties.size*100+'px'
                this.$refs.sceneMaterialPoint.style.height = this.pointInfo.showSet.defaultStyle ? '60px' : this.pointInfo.geoJson.geo.properties.size*100+'px'
              }
              this.animationImageName = "centerToAll"
              break;
            }

          }
          this.animationing = true;
          //监听开始动画结束，显示标题
          clearTimeout(this.animationingTemp)
          this.animationingTemp = setTimeout(()=>{
            this.animationing = false;

            //显示动画结束，开始监听消失动画
            //有消失动画：监听显示秒数（总显示时间-显示动画时间-消失动画时间）等待消失动画开始，进行隐藏动画
            //无消失动画，显示秒数（总显示时间-显示动画时间）
            if(this.pointInfo.showSet.materialHideAnimation !== "无"){
              clearTimeout(this.animationHideTemp)
              this.animationHideTemp = setTimeout(()=>{
                // console.log("开始隐藏")

                //隐藏动画
                switch(this.pointInfo.showSet.materialHideAnimation){
                  case "无":{

                    break;
                  }
                  case "淡出":{
                    this.animationName = "opacity1To0"
                    break;
                  }
                  case "浮入":{
                    this.animationName = "materialPointHeightAllTo0"
                    break;
                  }
                  case "扩展":{
                    this.animationImageName = "allToCenter"
                    // this.animationDuration = 3;
                    break;
                  }
                  case "翻跳":{
                    this.animationImageName = "allToCenter"
                    break;
                  }

                }

                this.animationing = true;
                //监听隐藏动画结束，显示标题
                clearTimeout(this.animationingTemp)
                this.animationingTemp = setTimeout(()=>{
                  this.animationing = false;
                  this.$refs.sceneMaterialPoint.style.display = "none";
                },this.animationDuration * 1000)
              },this.markerShowSeconds - this.animationDuration * 1000 - this.animationDuration * 1000)

            }
            else{

              //无消失动画
              clearTimeout(this.animationHideTemp)
              this.animationHideTemp = setTimeout(()=>{
                //无动画，直接消失
                this.$refs.sceneMaterialPoint.style.display = "none";
              },this.markerShowSeconds - this.animationDuration * 1000)

            }

          },this.animationDuration * 1000)
        }
        else{
          //无开始动画，直接监听消失动画
          //监听显示秒数（总显示时间-消失动画时间）等待消失动画开始，进行隐藏动画
          //无消失动画，显示秒数（总显示时间）
          if(this.pointInfo.showSet.materialHideAnimation !== "无"){
            clearTimeout(this.animationHideTemp)
            this.animationHideTemp = setTimeout(()=>{
              // console.log("开始隐藏")
              //隐藏动画
              switch(this.pointInfo.showSet.materialHideAnimation){
                case "无":{

                  break;
                }
                case "淡出":{
                  this.animationName = "opacity1To0"
                  break;
                }
                case "浮入":{
                  this.animationName = "materialPointHeightAllTo0"
                  break;
                }
                case "扩展":{
                  this.animationImageName = "allToCenter"
                  break;
                }
                case "翻跳":{
                  this.animationImageName = "allToCenter"
                  break;
                }

              }
              this.animationing = true;
              //监听隐藏动画结束，显示标题
              clearTimeout(this.animationingTemp)
              this.animationingTemp = setTimeout(()=>{
                this.animationing = false;
                this.$refs.sceneMaterialPoint.style.display = "none";
              },this.animationDuration * 1000)
            },this.markerShowSeconds - this.animationDuration * 1000)

          }
          else{
            //无消失动画
            clearTimeout(this.animationHideTemp)
            this.animationHideTemp = setTimeout(()=>{
              //无动画，直接消失
              this.$refs.sceneMaterialPoint.style.display = "none";
            },this.markerShowSeconds)

          }

        }


      },this.markerShowAnimationBeginSeconds)


      //监听结束动画结束的秒数，到达时清空所有监听
      clearTimeout()
      this.animationFinishTemp = setTimeout(()=>{
        this.animationing = false;
        this.$refs.sceneMaterialPoint.style.display = "none";
        clearTimeout(this.animationShowTemp)
        clearTimeout(this.animationingTemp)
        clearTimeout(this.animationHideTemp)

      },this.markerHideAnimationEndSeconds)



    },


    //获取标记第一幅图片
    getMarkerFirstImageSrc(){
      for(let i=0;i<this.pointInfo.geoJson.geo.properties.imageList.length;i++){
        if(this.pointInfo.geoJson.geo.properties.imageList[i].type === "image"){
          this.markerFirstImageSrc = this.pointInfo.geoJson.geo.properties.imageList[i].thumb
          break;
        }
      }
    }

  },
  mounted() {
    if(this.pointInfo.showSet.defaultStyle){
      this.pointImageName = "marker_one_blue1"
      this.pointImageFolder = "marker_one"
      this.getPointImageFinish = true;
    }
    else{
      this.getPointImage(this.pointInfo.geoJson.geo.properties.code,this.pointInfo.geoJson.geo.properties.color);
    }

    //获取第一幅配图
    this.getMarkerFirstImageSrc()


    let tempInterval = setInterval(()=>{
      if(this.getPointImageFinish){
        //当前正在播放或预览，需要考虑动画
        if(this.$store.state.sceneCurrPlayItem !== ""){

          if(this.pointInfo.showSet.allShowInScenePoint){
            //在项目中常显，不做动画操作


          }
          else{
            this.getShowSeconds()

            //有显示时间
            if(this.markerShowSeconds !== 0){
              //先设为隐藏，等动画时间出现
              this.$refs.sceneMaterialPoint.style.display = "none";
              //标记显隐动画
              this.beginAnimation()
            }
            else{
              //没有显示时间，不显示点
              this.$refs.sceneMaterialPoint.style.display = "none";
            }
          }

        }
        else{
          //没有动画
        }

        this.marker = new mapboxgl.Marker(this.$refs.sceneMaterialPoint,{
          anchor:"bottom",
          offset:[0,8]   //marker的高度自动比内部多8像素
        })
            .setLngLat(this.pointInfo.geoJson.geo.geometry.coordinates)
            .addTo(this.$parent.$parent.map)
        clearInterval(tempInterval)

        // console.log(this.marker)

      }

    })

  },
  destroyed() {
    clearTimeout(this.animationShowTemp)
    clearTimeout(this.animationingTemp)
    clearTimeout(this.animationHideTemp)
    clearTimeout(this.animationFinishTemp)
    // console.log(this.marker)
    this.marker.remove()
  },
  render() {
    return null;
  },

}
</script>

<style scoped>

.sceneMaterialPoint{
  position:absolute;
  cursor:pointer;
  animation-fill-mode:forwards;
}


</style>


<style>
/*各种标记动效*/

/*从地面出现*/
@keyframes materialPointHeight0ToAll {
  from {height:0;}
  to {height:var(--material-point-size);}   /*css变量，标记应设的高度，在js中赋值*/
}
/*进入地面隐藏*/
@keyframes materialPointHeightAllTo0 {
  from {height:var(--material-point-size);}
  to {height:0;}
}

/*从侧面出现*/
@keyframes materialPointWidth0ToAll {
  from {width:0;}
  to {width:var(--material-point-size);}
}
/*从侧面隐藏*/
@keyframes materialPointWidthAllTo0 {
  from {width:var(--material-point-size);}
  to {width:0;}
}


/*透明度*/
@keyframes opacity0To1 {
  from {opacity:0;}
  to {opacity:1;}
}
@keyframes opacity1To0 {
  from {opacity:1;}
  to {opacity:0;}
}


/*绑定在img，弹跳*/
@keyframes centerToAll {
  from {width:0;height:0;}
  to {width:var(--material-point-size);height:var(--material-point-size);}
}
@keyframes allToCenter {
  from {width:var(--material-point-size);height:var(--material-point-size);}
  to {width:0;height:0;}
}





</style>